import { render, staticRenderFns } from "./cfluckydrawblack.vue?vue&type=template&id=3ecfc64c"
import script from "./cfluckydrawblack.vue?vue&type=script&lang=js"
export * from "./cfluckydrawblack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports